import { Component, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { BaseActionComponent } from './base-action.component'

@Component({
  selector: 'copy-action',
  templateUrl: './copy-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyActionComponent extends BaseActionComponent {

  constructor(public el: ElementRef) {
    super(el)
  }
}
